export class ListRolesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "roles",
            "baseName": "roles",
            "type": "Array<Role>",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListRolesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
